<section>
    <div class="container">
        <h1 class="search-heading">Search results for <span>{{textInput}}</span></h1>
        <div class="main">
            <div class="prod-grid">
                <div class="prod-cell" *ngFor="let item of products">
                    <div class="product-item" (click)="productDetails(item)">
                        <figure class="product-thumb">
                            <img [src]="item.images[0].image_url" alt="">
                            <!-- <div class="action-links">
                                <button class="btn btn-cart">Add To Cart</button>
                            </div> -->
                        </figure>
                        <div class="product-content">
                            <h5 class="product-name text-truncate"><a>{{item.name}}</a></h5>
                            <div class="ratings">
                                <a *ngFor="let rate of item.rating_arr"><i class="ti-star"></i></a>
                            </div>
                            <div *ngIf="item.rating_arr.length == 0" class="ratings">
                                    <a><i class="ti-star"></i></a>
                                    <a><i class="ti-star"></i></a>
                                    <a><i class="ti-star"></i></a>
                                    <a><i class="ti-star"></i></a>
                                    <a><i class="ti-star"></i></a>
                                </div>
                            <span class="price-was" *ngIf="item.discount > 0">LE {{ item.price }}</span>
                            <p class="price">LE {{ effectivePrice(item) }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="product_massge" class="search-empty">
                <p>{{product_massge}}</p>
            </div>
        </div>
    </div>
</section>